// extracted by mini-css-extract-plugin
module.exports = {"landingPageCard":"card-list-module--landing-page-card--2fab6"};